/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { defineResource } from 'pulse/resources';
import { fromRPC } from 'pulse/adapters';
import * as References from './TicketsRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

// RPC Resources

export const SearchTicketsRpc = defineResource({
  typeName: 'com.hubspot.support.portal.rpc.TicketsRpc.searchTickets',
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  resolver: fromRPC({
    rpc: References.searchTicketsRpc,
    rpcClient: chirpClient
  })
}).register();
export const SearchTicketsForNavigationRpc = defineResource({
  typeName: 'com.hubspot.support.portal.rpc.TicketsRpc.searchTicketsForNavigation',
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  resolver: fromRPC({
    rpc: References.searchTicketsForNavigationRpc,
    rpcClient: chirpClient
  })
}).register();
export const GetTicketDetailsRpc = defineResource({
  typeName: 'com.hubspot.support.portal.rpc.TicketsRpc.getTicketDetails',
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  resolver: fromRPC({
    rpc: References.getTicketDetailsRpc,
    rpcClient: chirpClient
  })
}).register();
export const GetTicketContactsRpc = defineResource({
  typeName: 'com.hubspot.support.portal.rpc.TicketsRpc.getTicketContacts',
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  resolver: fromRPC({
    rpc: References.getTicketContactsRpc,
    rpcClient: chirpClient
  })
}).register();